import { render, staticRenderFns } from "./marketTaskTemplate.vue?vue&type=template&id=754e1dda&scoped=true&"
import script from "./marketTaskTemplate.vue?vue&type=script&lang=js&"
export * from "./marketTaskTemplate.vue?vue&type=script&lang=js&"
import style0 from "./marketTaskTemplate.vue?vue&type=style&index=0&id=754e1dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754e1dda",
  null
  
)

export default component.exports